
      import API from "!../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.102.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.102.1/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.102.1/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.102.1/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.102.1/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.102.1/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../../node_modules/.pnpm/postcss-loader@8.2.0_@rspack+core@1.5.8_postcss@8.5.6_typescript@5.9.3_webpack@5.102.1/node_modules/postcss-loader/dist/cjs.js!./multi-agent-tokens.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../../node_modules/.pnpm/postcss-loader@8.2.0_@rspack+core@1.5.8_postcss@8.5.6_typescript@5.9.3_webpack@5.102.1/node_modules/postcss-loader/dist/cjs.js!./multi-agent-tokens.css";
       export default content && content.locals ? content.locals : undefined;
